import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mobile-slider-full',
  templateUrl: './mobile-slider-full.component.html',
  styleUrls: ['./mobile-slider-full.component.css']
})
export class MobileSliderFullComponent implements OnInit {

  constructor(private router: Router) {}
  
  ngOnInit(): void {
  }

  slides = [
    {
      image: 'https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/f587e724-e663-4706-c93b-e8a573519e00/public',
      title: '¡Bienvenido a VoyJaleas!',
      text: 'Te acompañamos en cada paso para que cumplir tu sueño de vivir en Europa sea sencillo y seguro.'
    },
    {
      image: 'https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/35dee814-e7dd-4bbd-9f69-2ea85e93b500/public',
      title: 'Desde Costa Rica hasta Europa',
      text: 'Te guiamos con trámites, universidades, seguros, y más. Vos solo te preocupás por empacar las maletas.'
    },
    {
      image: 'https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/7c1bf045-af76-4545-7652-d5d3cb9a0f00/public',
      title: 'Empecemos tu viaje',
      text: 'Usá esta app para avanzar en tu proceso paso a paso y con el apoyo de nuestro equipo en todo momento.'
    }
  ];
  

  currentSlide = 0;
  transition = 'transform 0.4s ease';
  touchStartX = 0;

  onTouchStart(event: TouchEvent) {
    this.touchStartX = event.changedTouches[0].screenX;
  }

  onTouchEnd(event: TouchEvent) {
    const touchEndX = event.changedTouches[0].screenX;
    const deltaX = this.touchStartX - touchEndX;

    if (deltaX > 50) {
      this.nextSlide();
    } else if (deltaX < -50) {
      this.prevSlide();
    }
  }

  nextSlide() {
    if (this.currentSlide < this.slides.length - 1) {
      this.currentSlide++;
    } else {
      this.finishIntro();
    }
  }

  prevSlide() {
    if (this.currentSlide > 0) {
      this.currentSlide--;
    }
  }

  getTransform() {
    return `translateX(-${this.currentSlide * 100}%)`;
  }

  finishIntro() {
    this.router.navigateByUrl('/home');
  }
}